import { useAsync } from '../../../utils/useAsync';
import { DashboardControllerProps } from './interfaces';
import { useBikletaPointsService } from '../../../services/bikletaPoints/bikletaPointsService';
import { useEffect, useState } from 'react';
import { useStore } from '../../../utils/useStore';

export const useDashboardViewController = (): DashboardControllerProps => {
  const bpService = useBikletaPointsService();
  const [isRefreshing, setIsrefreshing] = useState(false);
  const { activePoint, setSessionStatsData } = useStore();

  const eventsNames = [
    'benefit_detail_opened',
    'benefit_viewed',
    'benefit_qr_generated',
  ];

  const [analyticsData, , loadingAnalytics, executeAnalytics, , ,] = useAsync(bpService.postAnalytics,null,true);
  const [selectedPeriod, setSelectedPeriod] = useState('7daysAgo');

  useEffect(() => {
    if (activePoint && selectedPeriod) {
      executeAnalytics({
        pointId: activePoint._id,
        startDate: selectedPeriod,
        endDate: 'today',
        eventsNames: eventsNames,
      });
    }
  }, [activePoint, selectedPeriod]);


  const handleRefresh = async () => {
    try {
      setIsrefreshing(true);
      await executeAnalytics({
        pointId: activePoint._id,
        startDate: selectedPeriod,
        endDate: 'today',
        eventsNames: eventsNames,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setIsrefreshing(false);
    }
  };

  useEffect(() => {
    if (analyticsData) {
      setSessionStatsData(analyticsData);
    }
  }, [analyticsData]);

  return {
    statsRefresh: handleRefresh,
    isRefreshing,
    selectedPeriod,
    setSelectedPeriod,
    analyticsData,
    loadingAnalytics,
  };
};
